export type SnDrawerPosition = 'left' | 'right' | 'top' | 'bottom';
